import type { SDKOptions, Payment } from '@airwallex/components-sdk';

/**
 * `init({ locale })` — keep in sync with @airwallex/components-sdk `SDKOptions['locale']`.
 */
const PAYMENT_INIT_LOCALES: ReadonlySet<string> = new Set([
  'en',
  'zh',
  'ja',
  'ko',
  'ar',
  'fr',
  'es',
  'nl',
  'nl-NL',
  'de',
  'it',
  'zh-HK',
  'pl',
  'fi',
  'ru',
  'da',
  'id',
  'ms',
  'sv',
  'pt',
  'ro',
]);

/**
 * `element.update(..., { locale })` — keep in sync with `Payment.InitOptions['locale']` / `Payment.Locale`.
 */
const PAYMENT_ELEMENT_UPDATE_LOCALES: ReadonlySet<string> = new Set([
  'ar',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'he',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'si',
  'sv',
  'tr',
  'vi',
  'ur',
  'zh',
  'zh-HK',
]);

type PaymentInitLocale = NonNullable<SDKOptions['locale']>;
type PaymentElementLocale = NonNullable<Payment.InitOptions['locale']>;

export function toPaymentInitLocale(lang: string): PaymentInitLocale {
  if (lang && PAYMENT_INIT_LOCALES.has(lang)) {
    return lang as PaymentInitLocale;
  }
  return 'en';
}

export function toPaymentElementUpdateLocale(lang: string): PaymentElementLocale {
  if (lang && PAYMENT_ELEMENT_UPDATE_LOCALES.has(lang)) {
    return lang as PaymentElementLocale;
  }
  return 'en';
}
